import React, { useState, useEffect, useRef } from 'react';
import { X, Video } from 'lucide-react';
import { collection, addDoc, serverTimestamp, doc, updateDoc } from 'firebase/firestore';
import { db } from '../../../firebase.js';
import { Editor as ToastEditor } from '@toast-ui/react-editor';
import '@toast-ui/editor/dist/toastui-editor.css';
import { getStorage, ref as storageRef, uploadBytes, getDownloadURL } from 'firebase/storage';
import app from '../../../firebase.js';

const NewsForm = ({ newsItem = null, onSaved, onCancel }) => {
  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');
  const editorRef = useRef(null);
  const storage = getStorage(app);
  const [videoUrl, setVideoUrl] = useState('');
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (newsItem) {
      setTitle(newsItem.title || '');
        setContent(newsItem.content || '');
      setVideoUrl(newsItem.videoUrl || '');
      // set editor HTML if instance available
      try {
        const inst = editorRef.current?.getInstance && editorRef.current.getInstance();
        if (inst && newsItem.content) inst.setHTML(newsItem.content);
      } catch (e) {
        // ignore
      }
    } else {
      setTitle('');
      setContent('');
      setVideoUrl('');
    }
  }, [newsItem]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!title.trim()) return;
    setSaving(true);
    try {
      const editorHTML = (editorRef.current && editorRef.current.getInstance) ? editorRef.current.getInstance().getHTML() : content;

      if (newsItem && newsItem.id) {
        const ref = doc(db, 'news', newsItem.id);
        await updateDoc(ref, {
          title: title.trim(),
          content: editorHTML || '',
          videoUrl: videoUrl || '',
          published: true,
          updatedAt: serverTimestamp()
        });
        if (typeof onSaved === 'function') onSaved({ ...newsItem, title: title.trim(), content: editorHTML, videoUrl });
      } else {
        const payload = {
          title: title.trim(),
          content: editorHTML || '',
          videoUrl: videoUrl || '',
          published: true,
          createdAt: serverTimestamp()
        };
        const docRef = await addDoc(collection(db, 'news'), payload);
        if (typeof onSaved === 'function') onSaved({ id: docRef.id, ...payload });
      }
      // reset handled by parent via onSaved/onCancel
    } catch (err) {
      console.error('Error guardando anuncio:', err);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="news-form-modal">
      <form className="news-form" onSubmit={handleSubmit}>
        <button type="button" className="news-form-close" onClick={onCancel}><X size={18}/></button>
        <h3><Video size={16}/> {newsItem ? 'Editar anuncio' : 'Nuevo anuncio'}</h3>
        <input
          type="text"
          placeholder="Título"
          value={title}
          onChange={e => setTitle(e.target.value)}
          required
        />
        <div style={{ marginBottom: '0.5rem' }}>
          <ToastEditor
            initialValue={content || ''}
            previewStyle="vertical"
            height="240px"
            initialEditType="wysiwyg"
            useCommandShortcut={true}
            ref={editorRef}
            hooks={{
              addImageBlobHook: async (blob, callback) => {
                try {
                  const fileRef = storageRef(storage, `news_images/${Date.now()}_${blob.name}`);
                  // provide contentType metadata to ensure Storage sets correct MIME type
                  const snap = await uploadBytes(fileRef, blob, { contentType: blob.type || 'application/octet-stream' });
                  const url = await getDownloadURL(snap.ref);
                  callback(url, blob.name);
                } catch (err) {
                  console.error('Error subiendo imagen:', err);
                  alert('Error subiendo imagen. Revisa la consola.');
                }
                return false;
              }
            }}
          />
        </div>
        <input
          type="url"
          placeholder="URL de video (opcional)"
          value={videoUrl}
          onChange={e => setVideoUrl(e.target.value)}
        />
        <button type="submit" className="news-form-submit" disabled={saving}>{saving ? 'Guardando...' : (newsItem ? 'Actualizar' : 'Publicar')}</button>
      </form>
    </div>
  );
};

export default NewsForm;
